var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.02,
    height: 18.682,
    viewBox: "0 0 24.02 18.682",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "map-solid",
    d: "M0,35.572V50.014a.667.667,0,0,0,.915.62l5.757-2.621V32L.839,34.333A1.335,1.335,0,0,0,0,35.572ZM8.007,48.013l8.007,2.669V34.669L8.007,32Zm15.1-15.965-5.757,2.621V50.682l5.833-2.333a1.334,1.334,0,0,0,.839-1.239V32.668A.667.667,0,0,0,23.105,32.048Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSolid);
export default __webpack_public_path__ + "static/media/map-solid.1f7e6102b52f2e9955ca820733a910d7.svg";
export { ForwardRef as ReactComponent };